module.exports = __webpack_public_path__ + "static/media/screenshot(37).1d8b6461.jpg";